import React, { useEffect, useRef, useState } from "react";
import LoadingSpinner from "../components/common/LoadingSpinner";
import { httpReauest } from "../utils/httpRequest";
import { Link, useNavigate } from "react-router-dom";
import {
  FaArrowLeft,
  FaShoppingCart,
  FaUtensils,
  FaHome,
  FaGamepad,
  FaUser,
  FaShoppingBag,
  FaTimes,
} from "react-icons/fa";
import { MdLocationOn } from "react-icons/md";
import Layout from "../components/layout";
import { CDN_BASE_URL } from "../config";
import { FaAngleLeft, FaAngleRight, FaDoorOpen } from "react-icons/fa6";
import { IoIosLogOut } from "react-icons/io";
import { LuLogOut } from "react-icons/lu";
import {
  Add,
  ArrowLeft,
  ArrowLeft2,
  ArrowRight2,
  Location,
  Logout,
  ShoppingBag,
} from "iconsax-reactjs";
import { toast } from "react-toastify";
import OrderCard from "../components/common/card/OrderCard";
import AddressItem from "../components/common/AddressItem";
import { useTranslation } from "react-i18next";

const Address = () => {
  const [loading, setLoading] = useState(true);
  const [data, setdata] = useState();
  const [addresses, setAddresses] = useState([]);
  const navigate = useNavigate();

  const { t } = useTranslation();

  useEffect(() => {
    getData();
  }, []);

  const getAddresses = async (userId, token) => {
    try {
      const res = await httpReauest(
        "GET",
        `/user/address/${userId}`,
        {},
        { "x-access-token": token }
      );
      setAddresses(res.data.data);
    } catch (error) {
      console.error("خطا در دریافت آدرس‌ها", error);
    }
  };

  async function getData() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) {
      navigate("/login");
    }
    await httpReauest(
      "GET",
      "/user/info/" + user?._id,
      {},
      { "x-access-token": user?.token }
    )
      .then((res) => {
        const userInfo = res.data.data?.user;
        setdata(userInfo);
        getAddresses(userInfo._id, user.token);
      })
      .catch(() => {
        localStorage.removeItem("user");
        navigate("/login");
      });
    setLoading(false);  
  }

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="min-h-screen  flex flex-col px-4">
      <div className="flex justify-end py-4">
        <Link to={"/profile"}>
          <ArrowLeft />
        </Link>
      </div>
      <div className="flex justify-between items-start px-3 py-2 bg-white shadow rounded-[8px]">
        <div className="flex gap-2 items-center">
          <Location size={22} />
          {t("nav_addresses")}
        </div>
        <Link
          to={"/profile/add-address"}
          className="text-blue-500 flex gap-1 items-center"
        >
          {t("new-address")}
          <Add />
        </Link>
      </div>
      <div className="py-4 grid gap-4">
        {addresses.length > 0 ? (
          addresses.map((address) => (
            <span
              key={address._id}
              className="px-3 py-2 bg-white shadow rounded-[8px]"
            >
              <AddressItem data={address} />
            </span>
          ))
        ) : (
          <p className="text-sm text-gray-500 px-2">
            {t("no_addresses_found")}
          </p>
        )}
      </div>
    </div>
  );
};

export default Address;
